import React, { useState, useEffect } from 'react';
import '../profile.scss';
import { Text, Dropdown } from '@ui-kit';

const ProfileRole = ({ 
  formData = {},
  onChangeInput = () => {},
  user = {},
  disabled = false
}) => {
  const Roles = [
    { name: 'User', value: 'USER'},
    { name: 'Admin', value: 'ADMIN' },
    { name: 'Tester', value: 'TESTER' }
  ];
  const SubRoles = [
    { name: 'Default', value: '' },
    { name: 'MyTeamArt', value: 'MYTEAMART'},
    { name: 'Tester', value: 'TESTER'},
    { name: 'KH Classic', value: 'KHCLASSIC' },
    { name: 'KH Lite', value: 'KHLITE' },
    { name: 'KH Trial', value: 'KHTRIAL' },
    { name: 'KH Ferma', value: 'KHFERMA' },
    { name: 'PM Classic', value: 'PMCLASSIC' },
    { name: 'PM Plus', value: 'PMPLUS' },
    { name: 'PM Free', value: 'PMFREE' },
  ];
  const {id, role = '', subRole = ''} = user;
  const [roleValue, setRoleValue] = useState(role);
  const [subRoleValue, setSubRoleValue] = useState(subRole);

  useEffect(() => {
    formData.role = role;
    formData.subRole = subRole;

    const currentRole = Roles.find(
      (item) => item.value === role
    );

    const currentSubRole = SubRoles.find(
      (item) => item.value === subRole
    );
    
    setRoleValue(currentRole?.value || '');
    setSubRoleValue(currentSubRole?.value || '');
    // eslint-disable-next-line
  }, [id]);

  const renderRolePreview = (event, index) => {
    const name = event.name;
    const value = event.value;
    let classes = ['pr', 'executor__wrapper', 'input-search__item'];

    if (!name) return;

    if (value === roleValue) {
      classes.push('active');
    }

    return (
      <div
        className={classes.join(' ')}
        key={`role-${index}`}
        onClick={() => onSelectValue(value, 'role')}
      >
        <Text as='span'>{name}</Text>
      </div>
    );
  };

  const renderSubRolePreview = (event, index) => {
    const name = event.name;
    const value = event.value;
    let classes = ['pr', 'executor__wrapper', 'input-search__item'];

    if (!name) return;

    if (value === subRoleValue) {
      classes.push('active');
    }

    return (
      <div
        className={classes.join(' ')}
        key={`subRole-${index}`}
        onClick={() => onSelectValue(value, 'subRole')}
      >
        <Text as='span'>{name}</Text>
      </div>
    );
  };

  // Раньше здесь formData мутировался напрямую (formData.subRole = value). Значение в объект
  // попадало, но React об этом не знал: родитель не перерисовывался, и блоки, завязанные на
  // роль (например поля Patreon у TESTER), появлялись только после сохранения и перезагрузки.
  // Теперь идём через onChangeInput — тот же путь, что у обычных полей формы.
  const onSelectValue = (value, type) => {
    const name = type === 'subRole' ? 'subRole' : 'role';

    onChangeInput({ target: { name, value } });

    if (name === 'subRole') {
      setSubRoleValue(value);
      return;
    }

    setRoleValue(value);
  };

  return (
    <>
      <div className="profile__input mb-43">
        <label className="dropdown-label">Role</label>
        <Dropdown
          id="input-role"
          data={Roles}
          placeholder="Select role"
          search={false}
          renderOption={renderRolePreview}
          value={formData?.role || ''}
          isDisabled={disabled}
          onChange={onChangeInput}
        />
      </div>
      <div className="profile__input mb-20">
        <label className="dropdown-label">Sub Role</label>
        <Dropdown
          id="input-subRole"
          data={SubRoles}
          placeholder="Select subRole"
          search={false}
          renderOption={renderSubRolePreview}
          value={formData?.subRole || ''}
          isDisabled={disabled}
          onChange={onChangeInput}
        />
      </div>
    </>
  );
};

export default ProfileRole;
